import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { PharmacIcon } from '@pharmac/ui'

const IconStyles = css`
  margin-right: var(--spacing-small);
  align-self: center;

  @media (max-width: 835px) {
    margin-right: 0.5rem;
  }
`

export const AlertIcon = styled(PharmacIcon)`
  ${IconStyles}

  color: #db524b;
`

export const DownArrowIcon = styled(PharmacIcon)`
  ${IconStyles}

  color: #f2ae43;
`

export const CheckIcon = styled(PharmacIcon)`
  ${IconStyles}

  color: #72b763;
`

export const ClosedIcon = styled(PharmacIcon)`
  ${IconStyles}

  color: #868686;
`

export const StarIcon = styled(PharmacIcon)`
  ${IconStyles}

  color: #F2AE43;
`

export const ClockIcon = styled(PharmacIcon)`
  ${IconStyles}

  color: #00B0B9;
`

export const PersonIcon = styled(PharmacIcon)`
  ${IconStyles}

  color: #88288F;
`
